const Currency = [
	'AED',
	'AUD',
	'BRL',
	'CAD',
	'CHF',
	'CNY',
	'EUR',
	'GBP',
	'HKD',
	'INR',
	'JPY',
	'MAD',
	'QAR',
	'RUB',
	'SAR',
	'SGD',
	'THB',
	'USD',
	'XAF'
]

export default Currency



// WEBPACK FOOTER //
// ./src/common/components/MyPatrimonialLandscape/data/Currency.js